import DOMPurify from 'dompurify';

export class GuideChatManager {
    constructor(aiChat) {
        this.aiChat = aiChat;
    }

    scrollToBottom() {
        if (! this.aiChat.$chatBox || ! this.aiChat.$chatBox[0]) return;

        this.aiChat.$chatBox[0].scrollTo({
            top: this.aiChat.$chatBox[0].scrollHeight,
            behavior: 'smooth'
        });
    }

    restoreHistory() {
        $('.js_ai-guide-chat-trigger').one('click', () => {
            this.loadHistory();
        });
    }

    loadHistory() {
        $.getJSON('/ai/chat/guide/history', (history) => {
            if (!this.hasHistory(history)) return;

            this.aiChat.chatId = history.chatId;
            const htmlSteps = [];

            history.steps.forEach(step => {
                if (!step || !step.question || !step.answer) return;

                this.aiChat.allQuestions.push(step.question);

                htmlSteps.push(
                    `<div class="chat-bubble user">${DOMPurify.sanitize(step.question)}</div>`
                    + `<div class="chat-bubble bot">${DOMPurify.sanitize(step.answer)}</div>`
                    + (step.products || '')
                );
            });

            this.aiChat.$chatBox.append(htmlSteps.join(''));
            this.aiChat.$chatBox.removeClass('hidden');
            this.scrollToBottom();
            this.handleResetButton();
        });
    }

    hasHistory(history) {
        return history?.chatId
            && Array.isArray(history.steps)
            && history.steps.length;
    }

    handleResetButton() {
        const $resetButton = $(this.aiChat.$el).find('.js_reset-chat-btn');

        if (!$resetButton.length) return;

        this.aiChat.allQuestions.length
            ? $resetButton.removeClass('hidden')
            : $resetButton.addClass('hidden');

        $resetButton.off('click').on('click', () => {
            this.resetHistory();
        });
    }

    resetHistory() {
        $.ajax({
            url: '/ai/chat/guide/history/forget',
            type: 'DELETE',
            complete: () => {
                this.aiChat.allQuestions = [];
                this.aiChat.chatId = null;
                $(this.aiChat.$el).find('.chat-box').empty().addClass('hidden');
                this.handleResetButton();
            },
        });
    }
}
